import React from 'react';
import { Section } from '../ui/Section';
export function Hook() {
  return <Section theme="black" className="border-b border-gold-hairline" data-id="element-55">
      <div className="relative" data-id="element-56">
        <span className="absolute -top-16 -left-8 text-[120px] font-serif text-gold/10 leading-none select-none" data-id="element-57">
          "
        </span>

        <h2 className="text-3xl md:text-5xl font-serif font-medium italic leading-tight mb-10 text-gold relative z-10" data-id="element-58">
          The "American Dream" is being held hostage.
        </h2>

        <div className="space-y-8 text-lg md:text-xl text-bone-muted font-sans leading-relaxed max-w-3xl" data-id="element-59">
          <p data-id="element-60">
            While you're sitting at your kitchen table staring at a rent
            increase notice from your landlord, the "pros" are at the courthouse
            steps buying houses for{' '}
            <strong className="text-bone font-medium" data-id="element-61">
              $50k, $70k, or $100k below
            </strong>{' '}
            what you see on Zillow.
          </p>
          <p data-id="element-62">
            They've spent years convincing you that auctions are "too risky" or
            "cash only" so you'll stay in the retail market, fighting 50 other
            desperate buyers for overpriced scraps.
          </p>
        </div>
      </div>
    </Section>;
}